import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import React from 'react';
import { Icon } from '@trybeapp/ui.icon';

var _excluded = ["alt"];
var content = {
  width: 15,
  height: 15,
  block: '<path d="M100,6.26760563 C100,2.75774648 97.25,0 93.75,0 L6.25,0 C2.75,0 0,2.75774648 0,6.26760563 C0,7.8971831 0.625,9.27605634 1.625,10.4042254 C1.625,10.4042254 1.625,10.4042254 1.625,10.4042254 L45.375,60.5450704 L45.375,60.5450704 C46.5,61.7985915 48.125,62.6760563 50,62.6760563 C51.875,62.6760563 53.5,61.7985915 54.625,60.5450704 L54.625,60.5450704 L98.375,10.4042254 L98.375,10.4042254 C99.375,9.27605634 100,7.8971831 100,6.26760563 Z" fill="currentColor"/>'
};
var CaretDownIcon = function CaretDownIcon(_ref) {
  var _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'Down' : _ref$alt,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Icon, _extends({
    alt: alt,
    content: content
  }, props));
};

export { CaretDownIcon };
